import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Landing from "./landing";
import { Router } from "./Router";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);
